// extracted by mini-css-extract-plugin
export default {"modalContainer":"b4","fadeIn":"c4","img":"e4","fadeInImg":"f4","greeting":"g4","fadeInGreeting":"h4","imgWrapper":"i4","name":"j4","fadeInName":"k4"};
    if(module.hot) {
      // 1715632479328
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  